import React from 'react';
import styled from 'styled-components';
import { Icon } from '@panel/commons';

const IconWrapper = styled.div`
  align-self: center;
  pointer-events: none;
  transition: transform 0.2s ease-in-out;
  &.selected {
    transform: rotate(180deg);
  }
`;

function CloseFilterGroupButton(props) {
  const { groupTitle } = props;
  return (
    <IconWrapper className={groupTitle === 'status' ? 'selected' : ''}>
      <Icon name='chevronUp' width={16} height={16} viewBox='0 0 15 15' colorFill='enabled' />
    </IconWrapper>
  );
}

export { CloseFilterGroupButton };
